import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import OperationSection from './components/OperationSection';
import VisionSection from './components/VisionSection';
import ProductSection from './components/ProductSection';
import InvestmentSection from './components/InvestmentSection';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
import {
  heroData,
  problemData,
  solutionData,
  operationData,
  visionData,
  productData,
  investmentData,
  footerData
} from './data/mock';
import './App.css';

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactModalTab, setContactModalTab] = useState('pitch');

  const handleContactClick = () => {
    setContactModalTab('pitch');
    setIsContactModalOpen(true);
  };

  const handleCallClick = () => {
    setContactModalTab('meeting');
    setIsContactModalOpen(true);
  };

  return (
    <div className="App">
      <Navbar onContactClick={handleContactClick} />
      <Hero 
        data={heroData} 
        onContactClick={handleContactClick} 
        onCallClick={handleCallClick}
      />
      <ProblemSection data={problemData} />
      <SolutionSection data={solutionData} />
      <OperationSection data={operationData} />
      <VisionSection data={visionData} />
      <ProductSection data={productData} />
      <InvestmentSection 
        data={investmentData}
        onContactClick={handleContactClick}
        onCallClick={handleCallClick}
      />
      <Footer data={footerData} />
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)}
        initialTab={contactModalTab}
      />
    </div>
  );
}

export default App;
